import type { AttachmentDTO } from '@invenco/supply-interface';

import { Card } from '@/components/core/card';

type Props = {
  attachments?: AttachmentDTO[] | null;
};

export function ReturnAttachmentsGrid({ attachments }: Props) {
  if (!attachments?.length) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
      {attachments.map((attachment) => {
        const card = (
          <Card className="gap-2 p-4">
            {attachment.url ? (
              <div className="overflow-hidden rounded-md">
                <img
                  src={attachment.url}
                  alt={attachment.name ?? attachment.description ?? ''}
                  className="aspect-square w-full object-cover"
                />
              </div>
            ) : null}
            {attachment.description ? (
              <p className="text-left text-sm text-muted-foreground">{attachment.description}</p>
            ) : null}
          </Card>
        );

        return attachment.url ? (
          <a
            key={attachment.filePath}
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block rounded-xl transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            {card}
          </a>
        ) : (
          <div key={attachment.filePath}>{card}</div>
        );
      })}
    </div>
  );
}
